module.exports = __webpack_public_path__ + "static/img/r-4-4.40ba06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/r-4-4.png
// module id = zAEu
// module chunks = 0